//@flow
import ShellStoreClass from './shellStoreClass';

export default new ShellStoreClass();
